import { apiFetch } from './client.js';

type GetToken = () => Promise<string | null>;

export type Star = 'bronze' | 'silver' | 'gold' | 'diamond';

export interface Practice {
  id: string;
  athlete_client_id: string;
  practice_date: string;
  time_seconds: number;
  swing_count: number;
  types: string[];
  notes: string;
}

export interface PracticeSummary {
  practice_count: number;
  swing_count: number;
  time_seconds: number;
  current_streak: number;
  best_streak: number;
  current_star: Star | null;
  best_star: Star | null;
  stars: Record<Star, number>;
}

/** The date on the phone: a streak is counted in the athlete's days (ruled 1 November). */
function today(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

/** The practice calls: one athlete's page, one practice, and Type and notes. */
export const practiceCalls = {
  /** A signed-in athlete names nobody: it is their own. */
  list(getToken: GetToken, athleteClientId: string | null) {
    const athlete = athleteClientId ? `&athlete=${encodeURIComponent(athleteClientId)}` : '';
    return apiFetch<{ summary: PracticeSummary; practices: Practice[] }>(`/api/practices?today=${today()}${athlete}`, getToken);
  },
  read(getToken: GetToken, practiceId: string) {
    return apiFetch<Practice>(`/api/practices/${encodeURIComponent(practiceId)}`, getToken);
  },
  update(getToken: GetToken, practiceId: string, edited: { types: string[]; notes: string }) {
    return apiFetch<Practice>(`/api/practices/${encodeURIComponent(practiceId)}`, getToken, {
      method: 'PATCH',
      body: JSON.stringify(edited),
    });
  },
};
